import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import Flag from 'components/Flag';
import VisuallyHidden from 'components/VisuallyHidden';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CurationItem(_ref) {
  var children = _ref.children,
    isComplete = _ref.isComplete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var iconName = isComplete ? 'ok' : 'warning';
  var color = isComplete ? 'positive' : 'negative';
  return /*#__PURE__*/_jsxs(Flag, {
    spacing: "xs",
    align: "top",
    token: /*#__PURE__*/_jsx(Icon, {
      vAlign: true,
      name: iconName,
      color: color
    }),
    children: [children, /*#__PURE__*/_jsxs(VisuallyHidden, {
      children: [' ', t(isComplete ? 'property_present_brackets' : 'property_missing_brackets')]
    })]
  });
}
export default CurationItem;